let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5rOL")).then(() => parcelRequire('9HUoo'));